"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var adjustUrlParams_1 = __importDefault(require("./adjustUrlParams"));
var isEmptyString_1 = __importDefault(require("./utils/isEmptyString"));
var addTruthyParamsToUrl = function (url, params) {
    if (params === void 0) { params = {}; }
    var activeFields = lodash_1.omitBy(params, isEmptyString_1.default);
    return adjustUrlParams_1.default(function (currentParams) { return (__assign(__assign({}, currentParams), activeFields)); }, url);
};
exports.default = addTruthyParamsToUrl;
